import { useNavigate, useLocation } from 'react-router-dom';
import cartimg from '../../../assets/V2-images/cartimg.svg';
import cartpdf from '../../../assets/V2-images/cartpdf.svg';
import cartvideo from '../../../assets/V2-images/cartvideo.svg';
import { Input, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import close from '../../../assets/V2-images/close.svg';
import deleteicon from '../../../assets/V2-images/deleteicon.png';
import addcomponent from '../../../assets/V2-images/addcomponent.svg';
import copyurlicon from '../../../assets/V2-images/copyurlicon.png';
import renameicon from '../../../assets/V2-images/renameicon.png';
import shareicon from '../../../assets/V2-images/shareicon.png';
import download from '../../../assets/V2-images/download.png';
import more_vert from '../../../assets/V2-images/more_vert.png';
import InputC from 'Common/Inputs/index.tsx';
import { Col, Row } from 'reactstrap';
import { useEffect, useState } from 'react';
import Axios from 'functions/Axios';
import {
  Changeassetstatus,
  DeleteDraftAssetURL,
  EditAssetDetailsURL,
  GetShareUrl,
  ListofCollectionsURL,
  Sharedata,
  editCollectionAssetsURL,
} from '../DAM_API/urls';
import { Deletemodel } from 'Common/Deletemodel';
import { toast } from 'react-toastify';
import { ButtonC } from 'Common/Buttons';
import { useDispatch } from 'react-redux';
import { DAM_SVG } from '../DamAssets';
import { setOpenPopup } from 'actions/damActions';
import ShareAssetSection from '../Components/Featured/ShareAsset';
import { setLoading } from 'actions/ui';
import { useDownloadAssets } from 'context/DownloadAssetsContext';

export const Griddata = ({
  assets,
  datashow,
  show,
  setAssets,
  FolderselectAsset,
  supportWebp,
  FromCollection = false,
  fromBrandAssets,
  trash
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [AddToCollectionModal, setAddToCollectionModal] = useState(false);
  const [selectedDamFieldId, setSelectedDamFieldId] = useState(null);
  const [textvalue, settextvalue] = useState();
  const [sharelink, setsharelink] = useState(false);
  const [addcollection, setaddcollection] = useState(false);
  const [datacollection, setDatacollection] = useState();
  const [datapass, setdatapass] = useState();
  const [showbar, setshowbar] = useState(false);
  const [linkdata, setlinkdata] = useState();
  const [modal, setmodal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [shareshow, setshareshow] = useState(false);
  const [indexdata, setindexdata] = useState();
  const dispatch = useDispatch();
  const { startDownload } = useDownloadAssets();

  const onClickHandler = (e, damFileId, index) => {
    if (selectedCount < 1) {
      if(fromBrandAssets){
        return
      }
      navigate('/dam/dam-asset-information_v2', { state: { props: damFileId } });
    } else {
      selectAsset(index);
    }
  };

  const closeBtn1 = (
    <img
      src={close}
      className="close"
      alt="closeicon"
      onClick={() => setAddToCollectionModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const closeBtn2 = (
    <img
      src={close}
      className="close"
      alt="closeicon"
      onClick={() => setaddcollection(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const handleChange = (evt) => {
    const { value } = evt.target;
    settextvalue(value);
  };

  const handleshow = (id) => {
    setshowbar(id === showbar ? null : id);
    setSelectedDamFieldId(id);
  };
  const toggleAddToCollection = () => {
    setAddToCollectionModal(!AddToCollectionModal);
  };

  const folderedit = async () => {
    try {
      const formData = new FormData();
      formData.append('damFileId', selectedDamFieldId);
      formData.append('assetName', textvalue);
      const response = await Axios.post(EditAssetDetailsURL, formData);

      if (response.data.success) {
        datashow();
        setAddToCollectionModal(false);
        toast.success(response?.data?.message ?? 'Edit Successfully'); // Moved toast.success here
      } else {
        // Handle error case
        toast.error('Edit Failed'); // Moved toast.error here
      }
    } catch (error) {
      // Handle error
      toast.error('Edit Failed'); // Moved toast.error here
    } finally {
      setAddToCollectionModal(false);
      setshowbar(false);
    }
  };

  const handledelette = async (e) => {
    try {
      setLoading(true);
      formData.append('fileId', selectedDamFieldId);
      const _data = {
        fileId: [selectedDamFieldId],
      };

      setTimeout(() => { }, 4000);
      const data = await Axios.post(DeleteDraftAssetURL, {
       ..._data,
      });
      setLoading(false);
      setAddToCollectionModal(false);
      setmodal(false);
      toast.success(data?.data?.message ?? 'deleted Successfully');
      datashow();
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
    const formData = new FormData();
  };

  const downloadimage = async (damFileId) => {
    try {

      await startDownload({
        fileId: [damFileId],
        folderId: [],
      })

    } catch (error) {
      console.error('Error downloading the file:', error);
      // toast.error('Download Failed');
    }
    setshowbar(false);
  };

  const downloadImages = async () => {
    try {
      const selectedDamFileIds = assets
        .filter((asset) => asset.selected)
        .map((asset) => asset.damFileId);

      await startDownload({
        fileId: [selectedDamFileIds],
        folderId: [],
      })

    } catch (error) {
      console.error('Error downloading the files:', error);
      // toast.error('Download Failed');
    }
  };

  const collectiondataadd = (damFileId) => {
    setdatapass(damFileId);
    setaddcollection(true);
  };

  const fetchCollection = async () => {
    try {
      const response = await Axios.get(ListofCollectionsURL + '?pageNo=${0}&rowSize=20`');
      if (!response.data.errorStatus) {
        setDatacollection(response?.data?.data);
      } else {
        // Handle error
      }
    } catch (error) {
      // Handle error
    }
  };

  useEffect(() => {
    fetchCollection();
  }, []);

  const handleCollectionClick = async (collectionID) => {
    try {
      const formData = new FormData();
      formData.append('collectionID', collectionID);
      formData.append('damIds_list', datapass);

      const response = await Axios.post(editCollectionAssetsURL, formData);

      if (response.data.success) {
        fetchCollection();
        toast.success(response.data.message);
      } else {
        // Handle error case
      }
    } catch (error) {
      toast.error(error?.message ?? 'Add Collection Failed');
    } finally {
      setaddcollection(false);
      setshowbar(false);
    }
  };

  const selectAsset = (index) => {
    if (FolderselectAsset) {
      FolderselectAsset(index);
      return;
    }
    let newAssets = assets;
    newAssets[index].selected = !assets[index].selected;
    setAssets((prev) => ({
      ...prev,
      files: [...newAssets],
    }));
  };

  const selectedCount = assets?.filter((asset) => asset?.selected)?.length;

  const renderActionButtons = () => {
    if (selectedCount > 0) {
      if (location.pathname.includes('/draft')) {
        return (
          <div
            className="d-flex align-items-center justify-content-center gap-1 pointer Secondary-Button large-button"
            onClick={Addassits}
          >
            <img src={download} alt="Addassets Icon" />
            <div className="">Add to Assets</div>
          </div>
        );
      } else {
        return (
          <>
            <div
              className="d-flex align-items-center justify-content-center gap-1 pointer Secondary-Button large-button"
              onClick={collectiondataadd}
            >
              <img src={download} alt="Download Icon" />
              <div className="">Add to Collection</div>
            </div>

            <div
              className="d-flex align-items-center justify-content-center gap-1 pointer Secondary-Button large-button"
              onClick={handleDelete}
            >
              <img src={deleteicon} alt="Delete Icon" />
              <div className="">{trash?"Delete":"Move to trash"}</div>
            </div>
            <div
              className="d-flex align-items-center justify-content-center gap-1 pointer Secondary-Button large-button"
              onClick={downloadImages}
            >
              <img src={download} alt="Download Icon" />
              <div className="">Download</div>
            </div>
          </>
        );
      }
    }
    return null;
  };

  const deletmodal = () => {
    setmodal(true);
  };

  const handleDelete = async () => {
    try {
      const selectedDamFileIds = assets
        .filter((asset) => asset.selected)
        .map((asset) => asset.damFileId);

      const formData = new FormData();
      selectedDamFileIds.forEach((id) => formData.append('fileId', id));
      const _data = {
        fileId: [selectedDamFileIds],
      };
      const response = await Axios.post(DeleteDraftAssetURL, {
        ..._data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.errorStatus) {
        toast.success(response?.data?.message ?? 'Deleted Successfully');
        const remainingAssets = assets.filter((asset) => !asset.selected);
        setAssets(remainingAssets);
        // setAllAssetsSelected(false);
      } else {
        console.error('Error deleting assets:', response.data.message);
        toast.error('Delete Failed');
      }
    } catch (error) {
      console.error('Error deleting assets:', error);
      toast.error('Delete Failed');
    }
  };

  const Addassits = async () => {
    try {
      const selectedDamFileIds = assets
        .filter((asset) => asset.selected)
        .map((asset) => asset.damFileId);

      const formData = new FormData();
      selectedDamFileIds.forEach((id) => formData.append('damIds_list', id));

      const response = await Axios.post(Changeassetstatus, formData);

      if (response.data.success) {
        toast.success(response?.data?.message ?? 'Added Successfully');
        const remainingImages = assets.filter((asset) => !asset.selected);
        setAssets(remainingImages);
      } else {
        console.error('Error adding assets:', response.data.message);
        toast.error('Add Failed');
      }
    } catch (error) {
      console.error('Error adding assets:', error);
      toast.error('Add Failed');
    }
  };

  const Copylink = (damFileId, url) => {
    if (url) {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          setsharelink(false);
          toast.success('Copied Successfully '); // Moved toast.success here
        })
        .catch((error) => {
          console.error('Failed to copy URL:', error);
          toast.error('Copy Failed'); // Moved toast.error here
        });
      return;
    }
    const selectedItem = assets?.find(
      (item) => item.damFileId && (item.damFileId === damFileId || item.clientId === damFileId),
    );
    if (selectedItem && selectedItem.fileUrl) {
      const fileUrl = selectedItem.fileUrl;

      navigator.clipboard
        .writeText(fileUrl)
        .then(() => {
          setsharelink(false);
          toast.success('Copied Successfully '); // Moved toast.success here
        })
        .catch((error) => {
          console.error('Failed to copy URL:', error);
          toast.error('Copy Failed'); // Moved toast.error here
        });
    } else {
      console.error('Selected item not found or missing fileUrl property.');
    }
    setshowbar(false);
  };

  const handleshowdata = async (damFileId, index) => {
    setindexdata(index);
    setsharelink(!sharelink);
    setshowbar(false);
    try {
      const response = await Axios.get(GetShareUrl + damFileId);
      setlinkdata(response?.data?.data);
    } catch (error) {
      console.error('Error fetching the share URL:', error);
    }
  };

  const Shareshowdata = () => {
    setshareshow(!shareshow);
  };

  const toggle = () => setmodal(!modal);
  return (
    <>
      {modal && (
        <Deletemodel
          deletemodal={modal}
          toggledelete={toggle}
          handleDelete={handledelette}
          loading={deleteLoading}
        />
      )}

      {sharelink && (
        <ShareAssetSection
          openModal={sharelink}
          ParentId={[selectedDamFieldId]}
          toggleOpenModal={() => {
            setsharelink(!sharelink);
          }}
        />
      )}

      <Modal isOpen={addcollection} toggle={collectiondataadd} style={{ width: '50%' }}>
        <ModalHeader toggle={collectiondataadd} close={closeBtn2}>
          Add to Collection
        </ModalHeader>
        <ModalBody>
          {datacollection &&
            datacollection.map((value) => {
              return (
                <p
                  className="pointer"
                  key={value.collectionID}
                  onClick={() => handleCollectionClick(value.collectionID)}
                >
                  {value.collection_name}
                </p>
              );
            })}
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}></ModalFooter>
      </Modal>

      <Modal isOpen={AddToCollectionModal} toggle={toggleAddToCollection} style={{ width: '50%' }}>
        <ModalHeader toggle={toggleAddToCollection} close={closeBtn1}>
          Rename Folder
        </ModalHeader>
        <ModalBody>
          <InputC
            type="text"
            label=""
            name="textvalue"
            placeholder="Enter name of folder"
            inputvalue={textvalue}
            change={(e) => handleChange(e)}
          />
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}>
          <ButtonC
            text="Close"
            color="Secondary"
            size="lg"
            click={() => setAddToCollectionModal(false)}
          />
          <ButtonC text="Save" size="lg" click={folderedit} />
        </ModalFooter>
      </Modal>

      <div className="mt-4">
        <div className="d-flex align-items-center justify-content-between">
          <div className="mb-2">
            <p className="showingdata">Showing {assets.length} assets</p>
          </div>
          <div className="d-flex align-items-center gap-2">{renderActionButtons()}</div>
        </div>
      </div>

      <div className="pt-3">
        <Row>
          {assets.map((value, index) => {
            return (
              <Col sm={5} md={3} xl={3} xxl={2} lg={4}>
                <div className=" boxdata mb-4" key={value.assetId}>
                  <div className="d-flex justify-content-between align-items-center imagecart">
                    {value.fileType === 'image' ? (
                      <img
                        src={cartimg}
                        alt=".."
                        onClick={(e) => onClickHandler(e, value.assetId)}
                        className="pointer"
                      />
                    ) : value.fileType === 'pdf' ? (
                      <img
                        src={cartpdf}
                        alt=".."
                        onClick={(e) => onClickHandler(e, value.assetId)}
                        className="pointer"
                      />
                    ) : (
                      <img
                        src={cartvideo}
                        alt=".."
                        onClick={(e) => onClickHandler(e, value.assetId)}
                        className="pointer"
                      />
                    )}

                    <div className="d-flex align-items-center">
                      <div
                        className="d-flex align-items-center checkbox-container"
                        style={{ paddingLeft: '6px' }}
                      >
                        {!FromCollection && (
                          <Input
                            className="draft-checkboxes"
                            type="checkbox"
                            onClick={() => selectAsset(index)}
                            checked={value.selected}
                            readOnly
                          />
                        )}
                      </div>

                      <img
                        src={more_vert}
                        alt="more_vert"
                        className="pointer"
                        onClick={() => handleshow(value?.assetId)}
                      />
                    </div>
                    {showbar === value?.assetId ? (
                      <div className="cart_list">
                        <div
                          className="d-flex align-items-center gap-2 pointer"
                          onClick={() => {
                            setSelectedDamFieldId(value?.assetId);
                            deletmodal();
                          }}
                        >
                          {' '}
                          <img src={deleteicon} alt="deleteicon" />{' '}
                          <p className="list_cart">Delete</p>
                        </div>
                        <div
                          className="d-flex align-items-center gap-2 pointer"
                          onClick={() => {
                            setSelectedDamFieldId(value?.assetId);
                            settextvalue(value.assetName);
                            setAddToCollectionModal(!AddToCollectionModal);
                          }}
                        >
                          <img src={renameicon} alt="renameicon" />
                          <p className="list_cart">Rename</p>
                        </div>
                        <div
                          className="d-flex align-items-center gap-2 pointer"
                          onClick={() => {
                            dispatch(
                              setOpenPopup({ value, id: value?.damFileId, assetType: 'file' }),
                            );
                          }}
                        >
                          {' '}
                          {DAM_SVG.permissionSvg}
                          <p className="list_cart">Invite Outside Org.</p>
                        </div>
                        {show ? (
                          <div
                            className="d-flex align-items-center gap-2 pointer"
                            onClick={() => collectiondataadd(value?.assetId)}
                          >
                            {' '}
                            <img src={addcomponent} alt="coomponenticon" />{' '}
                            <p className="list_cart">Add to Collection</p>
                          </div>
                        ) : (
                          ''
                        )}
                        <div
                          className="d-flex align-items-center gap-2 pointer"
                          onClick={() => downloadimage(value?.assetId)}
                        >
                          {' '}
                          <img src={download} alt="componenticon" />{' '}
                          <p className="list_cart">Download</p>
                        </div>

                        <div
                          className="d-flex align-items-center gap-2 pointer"
                          onClick={() => Copylink(value?.assetId)}
                        >
                          {' '}
                          <img src={copyurlicon} alt="componenticon" />{' '}
                          <p className="list_cart">Copy Link</p>
                        </div>
                        {/* <div className="d-flex align-items-center gap-2 pointer" onClick={() => Duplicate(value?.assetId)}> <img src={addcomponent} alt="componenticon"/> <p className="list_cart">Duplicate</p></div> */}

                        <div
                          className="d-flex align-items-center gap-2 pointer"
                          onClick={Shareshowdata}
                        >
                          <img src={shareicon} alt="componenticon" />
                          <p className="list_cart">Share</p>
                        </div>
                        {shareshow ? (
                          <>
                            <div
                              className="d-flex align-items-center gap-2 pointer"
                              onClick={() => handleshowdata(value?.assetId, 0)}
                            >
                              <img src={shareicon} alt="componenticon" />
                              <p className="list_cart">Public Link</p>
                            </div>

                            <div
                              className="d-flex align-items-center gap-2 pointer"
                              onClick={() => handleshowdata(value?.assetId, 1)}
                            >
                              {' '}
                              <img src={shareicon} alt="componenticon" />{' '}
                              <p className="list_cart">Private Link</p>
                            </div>
                          </>
                        ) : (
                          ''
                        )}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  <div
                    className={`filethumb ${value.fileFormat === 'png' && value.transparent === 'true' ? 'fileback' : ''}`}
                  >
                    {supportWebp ? (
                      <div
                        className="imageshowh"
                        style={{
                          backgroundImage: `url(${value.thumnnailUrl.replace('.png', '.avif')})`,
                        }}
                        onClick={(e) => onClickHandler(e, value?.assetId, index)}
                      />
                    ) : (
                      <div
                        className="imageshowh"
                        style={{ backgroundImage: `url(${value.thumnnailUrl})` }}
                        onClick={(e) => onClickHandler(e, value?.assetId, index)}
                      />
                    )}
                  </div>
                  <div className="bottomtext">
                    {supportWebp
                      ? value?.fileName?.length > 7
                        ? value?.fileName?.substring(0, 7) + '...' + '.avif'
                        : value?.fileName?.replace(/\.[^/.]+$/, '.avif')
                      : value?.fileName?.length > 7
                        ? value?.fileName?.substring(0, 7) + '...' + '.png'
                        : value?.fileName?.replace(/\.[^/.]+$/, '.png')}
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </>
  );
};
